export default {"src":"/_next/static/media/logo.b70961a8.svg","height":56,"width":187,"blurWidth":0,"blurHeight":0};